import(/* webpackMode: "eager" */ "/codebuild/output/src629848468/src/apps/fanychance/src/app/error.tsx");
